import { useQuery } from '@apollo/client';
import Companies from '@clearkit/icons/glyphs/Companies';
import People from '@clearkit/icons/glyphs/People';
import Search from '@clearkit/icons/glyphs/Search';
import { CKTab, CKTabList, CKTabs } from '@clearkit/react';
import capitalize from 'lodash/capitalize';

import AccountNotifications from '~/components/AccountNotifications';
import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';
import Tile from '~/images/Tiles/Enrichment.svg';
import { objectTypes, readableType, typeCompany } from '~/lib/dataEnrichment';
import history from '~/lib/history';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import FieldMappingForm from './FieldMappingForm';
import query from './query.graphql';

const EnrichmentShow = ({
  integration,
  objectType = objectTypes[integration][0].name,
}) => {
  const {
    data: { accountNotifications },
  } = useQuery(query, {
    returnPartialData: true,
  });

  const hasEnrichmentLogsFeatureFlag = useFeatureFlag('x_data_enrichment_logs');

  const integrationObjectTypes = objectTypes[integration];
  const currentTab =
    integrationObjectTypes.findIndex(
      (integrationObjectType) => integrationObjectType.name === objectType,
    ) || 0;

  return (
    <ConnectorLayout
      integration={integration}
      connectorLocation={connectorLocations.enrichment}
      subtitle={`Sync Clearbit data to ${readableType(integration)}`}
      breadcrumb={[
        {
          title: 'Data Sync',
          path: paths.dataEnrichmentIndex(),
        },
      ]}
      tabs={
        <CKTabs
          className="h-full"
          index={currentTab}
          onChange={(index) => {
            switch (index) {
              case 0:
              case 1:
              case 2:
                history.push(
                  paths.dataEnrichmentObject(
                    integration,
                    integrationObjectTypes[index].name,
                  ),
                );

                break;
              case 3:
                history.push(paths.dataEnrichmentLogs(integration));

                break;
            }
          }}
          isBordered>
          <CKTabList aria-label="My tabs">
            {integrationObjectTypes.map((integrationObjectType) => (
              <CKTab
                key={integrationObjectType.name}
                icon={
                  integrationObjectType.type === typeCompany ? (
                    <Companies />
                  ) : (
                    <People />
                  )
                }
                label={capitalize(integrationObjectType.name)}>
                {capitalize(integrationObjectType.name)}
              </CKTab>
            ))}

            {hasEnrichmentLogsFeatureFlag && integration === 'salesforce' && (
              // hide tab for non-salesforce sources until enrichmentLogs has been
              // abstracted
              <CKTab icon={<Search />} label="Enrichment Logs">
                Enrichment Logs
              </CKTab>
            )}
          </CKTabList>
        </CKTabs>
      }
      tile={<Tile />}>
      <AccountNotifications
        className="mx-10 mt-6 mb-2"
        notifications={accountNotifications}
        isFromEnrichmentPage
      />
      <div className="h-full">
        <FieldMappingForm
          integration={integration}
          objectType={integrationObjectTypes[currentTab]}
        />
      </div>
    </ConnectorLayout>
  );
};

export default EnrichmentShow;
